import { render, staticRenderFns } from "./fieldRelationCheckBox.vue?vue&type=template&id=054c6b91&scoped=true&"
import script from "./fieldRelationCheckBox.vue?vue&type=script&lang=js&"
export * from "./fieldRelationCheckBox.vue?vue&type=script&lang=js&"
import style0 from "./fieldRelationCheckBox.vue?vue&type=style&index=0&id=054c6b91&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054c6b91",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/bsx-uat.dianthus.com.tw/backstage_orig/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('054c6b91')) {
      api.createRecord('054c6b91', component.options)
    } else {
      api.reload('054c6b91', component.options)
    }
    module.hot.accept("./fieldRelationCheckBox.vue?vue&type=template&id=054c6b91&scoped=true&", function () {
      api.rerender('054c6b91', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/vue/vueFormFieldComponents/fieldRelationCheckBox.vue"
export default component.exports